import { useTranslation } from 'react-i18next';
import { BankAccountDtoIn } from '@/models/in/BankAccountDtoIn';
import IconWithText from '@/components/ui/IconWithText/IconWithText';
import bankIcon from '@/assets/icons/bank.svg';
import deleteIcon from '@/assets/icons/delete.svg';

interface ExistingPaymentInfosProps {
  paymentInfos: BankAccountDtoIn[];
  onDelete: (paymentInfo: BankAccountDtoIn) => void;
  /** מי מהחשבונות נמצא כרגע בתהליך מחיקה — הכפתור שלו נעול עד שהשרת עונה. */
  deletingId?: number | null;
}

const ExistingPaymentInfos = ({ paymentInfos, onDelete, deletingId }: ExistingPaymentInfosProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <h4 className="body-lr-semibold text-(--font-sub-title-2)">{t('existingPaymentInfos')}</h4>

      {!paymentInfos || paymentInfos.length === 0 ? (
        <div className="py-4">
          <span className="body-lr-regular text-(--font-body-2)">{t('noPaymentInfosYet')}</span>
        </div>
      ) : (
        <div className="flex flex-col gap-6 max-w-[720px]">
          {/* max-w: הפופאפ רחב 1132px, ובלי תקרה לרוחב השורה justify-between היה דוחף את
              כפתור המחיקה לקצה הרחוק של הדיאלוג — רחוק מהחשבון שהוא מוחק. */}
          {paymentInfos.map((paymentInfo) => (
            <div key={paymentInfo.id} className="flex gap-4 items-start justify-between">
              <div className="flex flex-col gap-2">
                <div className="flex gap-2 items-center">
                  <div className="h-[15px] border-l-2 border-(--border-tertiary-strong)"></div>
                  <span className="body-lr-semibold text-(--font-body-1)">{paymentInfo.accountOwnerName}</span>
                </div>
                <div className="flex flex-col">
                  <IconWithText
                    icon={bankIcon}
                    text={`${t('bank')} ${paymentInfo.bankNumber} (${paymentInfo.bankName}), ${t('branch')} ${paymentInfo.branchNumber}, ${t('account')} ${paymentInfo.accountNumber}`}
                  />
                </div>
              </div>

              <button
                type="button"
                onClick={() => onDelete(paymentInfo)}
                disabled={deletingId === paymentInfo.id}
                className="shrink-0 border border-(--border-main) rounded-lg p-2 hover:opacity-80 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
                title={t('deleteBankAccount')}
                aria-label={t('deleteBankAccount')}
              >
                <img src={deleteIcon} alt="" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ExistingPaymentInfos;
